export default {
      id: "huge-editor-bulleted-list-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-editor-bulleted-list",
      toString: function () {
        return this.url;
      }
    }